<template>
  <div
    class="modal fade"
    id="sys_apply_pay_e_bills_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title" id="myModalLabel">
            {{instance.define_name}}(当前节点 {{instance.node}}) No. {{instance.id}}
          </h4>
        </div>

        <!-- modal-body-->
        <div class="modal-body">
          <div class="form-horizontal">

            <div class="form-group">
              <label class="col-sm-2 control-label">申请时间:</label>
              <div class="col-sm-4">
                {{instance.create_at}}
              </div>
              <label class="col-sm-2 control-label">申请人:</label>
              <div class="col-sm-4">
                {{instance.initiator_name}}
              </div>
            </div>

            <div v-for="(eFlow,index) in eFlowList" :key="index" class="e-flow-item">
              <!--  信息展示区  -->
              <div class="col-sm-4">
                <h4>基站信息</h4>
                <div class="e-flow-station-info">
                  基站名称:{{eFlow.stst_commname || '未知基站名称'}} <br/>
                  运营商:{{eFlow.stst_comm}} <br/>
                  分管运营商:{{eFlow.stst_subcomm}} <br/>
                  收电费单价:{{eFlow.stst_commelectricity}} <br/>
                  收电费单价:{{eFlow.stst_ownerelectricity}} <br/>
                  局方合同起始日期:{{eFlow.stst_commcontractstar}} <br/>
                  局方合同终止日期:{{eFlow.stst_commcontractend}} <br/>
                </div>
                <h4>本次申请</h4>
                <div class="e-flow-form-info">
                  上次查表时间:{{eFlow.上次查表时间}} <br/>
                  上次表底数:{{eFlow.上次表底数}} <br/>
                  本次查表时间:{{eFlow.本次查表时间}} <br/>
                  本次表底数:{{eFlow.本次表底数}} <br/>
                  度数:{{eFlow.度数}} <br/>
                  金额:{{eFlow.金额}} <br/>
                  单价:{{eFlow.单价}} <br/>
                  支付方式:{{eFlow.支付方式}} <br/>
                  付款公司:{{eFlow.付款公司}} <br/>
                  实际支付日期:{{eFlow.实际支付日期}} <br/>
                  发票形式:{{eFlow.发票形式}} <br/>
                  发票税率:{{eFlow.发票税率}} <br/>
                </div>
              </div>
              <!--  图表展示区  -->
              <div class="col-sm-8">
                <table id="history-table" class="table table-striped table-bordered" style="width:100%">
                  <thead>
                  <tr>
                    <th>查表时间</th>
                    <th>表底数</th>
                    <th>度数</th>
                    <th>结算单价</th>
                    <th>结费金额</th>
                    <th>实际支付日期</th>
                    <th>备注</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(history,index) in eFlow.historys" :key="index" class="e-flow-history">
                    <td>{{history.current_time}}</td>
                    <td>{{history.current_reading}}</td>
                    <td>{{history.used}}</td>
                    <td>{{history.price}}</td>
                    <td>{{history.money}}</td>
                    <td>{{history.receipt_date}}</td>
                    <td>{{history.remark}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>

        <!-- modal-footer -->
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn btn-primary" @click="judgeApprove">通过</button>
          <button type="button" data-dismiss="modal" class="btn btn-danger" @click="judgeReject">拒绝</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      instance: {}, // 实例
      context: {}, // 上下文
      eFlowList: [] // 流水申请单列表
    }
  },

  props: [],

  mounted: function () {
    var self = this
    // $('#history-table').DataTable()
  },

  methods: {
    initFunc: function (instance) {
      var self = this
      console.log('___initFunc 传入 instance', instance)
      self.context = JSON.parse(instance.context)
      self.eFlowList = self.context.流水信息
      console.log('___self.context ', self.context.流水信息)
      self.instance = instance
      // self.station = self.context.station
      // self.payTask = self.context.payTask
      $('#sys_apply_pay_e_bills_modal').modal('show') // 展示 modal 框
    },
    judgeApprove: function () { // 审批通过
      this.submitJudge('approve')
    },
    judgeReject: function () { // 审批拒绝
      this.submitJudge('reject')
    },
    // 提交
    submitJudge: function (judge) {
      console.log('___judge', judge)
      var self = this
      var putData = {
        'judge': judge
      }
      self.global.axiosPut(
        self,
        `instance/${self.instance.id}/judge/`,
        putData,
        function (res) {
          console.log('审批返回结果', res)
          if (res.status === 'success') {
            alert('提交成功')
            $('#approval_list_table').bootstrapTable('refresh')
          } else
            alert('提交失败')
        },
        function () {
          alert('提交失败')
        }
      )
    }
  }
}
</script>

<style scoped>
  .e-flow-item {
    background-color: #c4c4c4;
    margin: 20px 0 20px 0;
    border: 1px solid gray;
    border-radius: 20px;
    overflow: hidden;
    font-size: 15px;
    line-height: 25px;
  }

  .e-flow-station-info {
    padding: 0 0 20px 20px;
  }

  .e-flow-form-info {
    padding: 0 0 20px 20px;
  }

  .e-flow-show-btn-panel {
    padding: 10px 10px 0 0;
    display: flex;
    justify-content: flex-end;
  }

  .e-flow-show-btn {
    margin: 5px;
  }

  .e-flow-show-btn-chart {
    height: 200px;
    background-color: #0e84b5;
  }
</style>



// WEBPACK FOOTER //
// src/views/approvalCenter/instanceApplyPayEBills.vue